/** How {@link useAppFeatureFlags} resolves which feature map to use. */
export const AppFeatureScope = {
  /** Client admin route when available; otherwise global. */
  Auto: 'auto',
  /** Signed-in user map (main portals). */
  Global: 'global',
  /** Per-customer map from super-admin assignments. */
  Customer: 'customer',
} as const

export type AppFeatureScope = (typeof AppFeatureScope)[keyof typeof AppFeatureScope]

export type ResolvedAppFeatureScope = typeof AppFeatureScope.Global | typeof AppFeatureScope.Customer
